import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const chunkReloadMarker = '__chunk_reload__';
const chunkFailedMessage = /Loading chunk [\\d]+ failed/i;

const handleChunkLoadError = () => {
  if (window[chunkReloadMarker]) return;
  window[chunkReloadMarker] = true;
  if (window.caches) {
    window.caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
      .finally(() => window.location.reload(true));
  } else {
    window.location.reload(true);
  }
};

window.addEventListener(
  'unhandledrejection',
  (event) => {
    const reason = event?.reason;
    if (reason?.name === 'ChunkLoadError' || chunkFailedMessage.test(reason?.message)) {
      handleChunkLoadError();
    }
  },
  false
);

window.addEventListener(
  'error',
  (event) => {
    const target = event?.target;
    if (target?.tagName === 'SCRIPT' && target.src?.includes('/static/js/')) {
      handleChunkLoadError();
    }
  },
  true
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
